import axios from 'axios';
import {Response} from '../../types/response/Response';
import {Application} from '../../types/project/Application';
import {ExecutionContainer} from '../../types/model/framework/ExecutionContainer';
import {PostProcessorType} from '../../types/postprocessor/PostProcessorType';

export type ParameterType = 'PRE_PROCESSOR' | 'POST_PROCESSOR';

export type UpdateParameterRequest = {
  id: string;
  name: string;
  value: string;
};

export type UpdateParametersRequest = {
  projectId: string;
  applicationId: string;
  spaId?: string;
  parameters: Array<UpdateParameterRequest>;
};

export type ResetParametersRequest = {
  projectId: string;
  applicationId: string;
  spaId?: string;
  parameterType: ParameterType;
  executionContainer?: ExecutionContainer;
  postProcessorType?: PostProcessorType;
};

export function updateParameters(request: UpdateParametersRequest) {
  return axios.post<Response<Application>>(
    '/studio/application/parameters/update',
    request
  );
}

export function resetParameters(request: ResetParametersRequest) {
  return axios.post<Response<Application>>(
    `/studio/application/parameters/reset`,
    request
  );
}
